export type TFilterForm = {
  status: 'all' | 'new' | 'processed' | 'deposited' | 'refunded' | 'rejected'
  brand_name: string
  location_id: string
  type:
    | 'all'
    | 'pickup'
    | 'delivery'
    | 'daas_delivery'
    | 'curbside'
    | 'dine-in'
    | 'takeout'
  begin_time: string
  end_time: string
  page: number
  order_id: string
}

export const statusOptions = [
  {
    label: 'All Status',
    value: '',
  },
  {
    label: 'New',
    value: 'new',
  },
  {
    label: 'Processed',
    value: 'processed',
  },
  {
    label: 'Deposited',
    value: 'deposited',
  },
  {
    label: 'Refunded',
    value: 'refunded',
  },
  {
    label: 'Rejected',
    value: 'rejected',
  },
]

export const filterTypeOptions = [
  { label: 'All Types', value: 'all' },
  { value: 'pickup', label: 'Pickup' },
  { value: 'delivery', label: 'Delivery (in-house)' },
  { value: 'daas_delivery', label: 'Delivery (on-demand)' },
  { value: 'curbside', label: 'Curbside' },
  { value: 'dine-in', label: 'Dine-in' },
  { value: 'takeout', label: 'Takeout' },
]

export const typeOptions = [
  { value: 'pickup', label: 'Pickup' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'daas_delivery', label: 'Delivery' },
  { value: 'curbside', label: 'Curbside' },
  { value: 'dine-in', label: 'Dine-in' },
  { value: 'takeout', label: 'Takeout' },
]
